import * as XLSX from 'xlsx';

const quitarAcentos = (s) => s
  .replace(/[áàäâã]/g, "a")
  .replace(/[éèëê]/g, "e")
  .replace(/[íìïî]/g, "i")
  .replace(/[óòöôõ]/g, "o")
  .replace(/[úùüû]/g, "u")
  .replace(/ñ/g, "n");

const slugify = (s) => {
  const base = quitarAcentos(String(s ?? "").toLowerCase());
  return base.replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "almacen";
};

export const nombreArchivoExcel = (vista, almacenNombre) => {
  const fecha = new Date().toISOString().slice(0, 10);
  return `${vista}_${slugify(almacenNombre)}_${fecha}.xlsx`;
};

const anchoColumnas = (filas) => {
  if (filas.length === 0) return [];
  const headers = Object.keys(filas[0]);
  return headers.map(h => {
    const maxLen = Math.max(h.length, ...filas.map(f => String(f[h] ?? "").length));
    return { wch: Math.min(Math.max(maxLen + 2, 10), 50) };
  });
};

// hojas: [{ nombre, filas }] — genera y descarga el .xlsx en el cliente
export const exportarExcel = (nombreArchivo, hojas) => {
  const wb = XLSX.utils.book_new();
  for (const { nombre, filas } of hojas) {
    const sheet = XLSX.utils.json_to_sheet(filas);
    sheet['!cols'] = anchoColumnas(filas);
    XLSX.utils.book_append_sheet(wb, sheet, nombre.slice(0, 31));
  }
  XLSX.writeFile(wb, nombreArchivo);
};
